import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayersCount = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2938_30166",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 100,
		height: 100,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 99,
			height: 99,
			fill: "#C4C4C4",
			stroke: "#9EA9B9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_2938_30166)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask1_2938_30166",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: -3,
			y: -3,
			width: 105,
			height: 105,
			children: /* @__PURE__ */ _jsx("rect", {
				x: -3,
				y: -3,
				width: 105,
				height: 105,
				fill: "#C4C4C4"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask1_2938_30166)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M46.7706 10.9226L49.5835 16.314C50.1304 15.1419 51.3181 12.4697 51.6931 11.157C52.1619 9.51613 54.2717 6 49.1147 6C44.9891 6 45.8329 9.28172 46.7706 10.9226Z",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46.6846 37.9226L49.4975 43.314C50.0445 42.1419 51.2321 39.4697 51.6072 38.157C52.076 36.5161 54.1857 33 49.0287 33C44.9031 33 45.747 36.2817 46.6846 37.9226Z",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M24.584 55.4998C30.6786 53.2339 44.2274 47.6237 49.6657 43.3105V43.4999C55.1041 47.813 68.6528 53.4231 74.7474 55.689V82.4149L49.6657 73.273L24.584 82.415V55.4998Z",
					fill: "#FDF1E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.6657 43.3105H50.1657C50.1657 43.1187 50.056 42.9438 49.8833 42.8604C49.7106 42.7769 49.5053 42.7996 49.355 42.9188L49.6657 43.3105ZM24.584 55.4998L24.4097 55.0312C24.2139 55.104 24.084 55.2909 24.084 55.4998H24.584ZM49.6657 43.4999H49.1657C49.1657 43.6525 49.2355 43.7968 49.355 43.8916L49.6657 43.4999ZM74.7474 55.689H75.2474C75.2474 55.4801 75.1175 55.2932 74.9216 55.2204L74.7474 55.689ZM74.7474 82.4149L74.5762 82.8847C74.7295 82.9406 74.9004 82.9182 75.0341 82.8246C75.1678 82.731 75.2474 82.5781 75.2474 82.4149H74.7474ZM49.6657 73.273L49.837 72.8032C49.7264 72.7629 49.6051 72.7629 49.4945 72.8032L49.6657 73.273ZM24.584 82.415H24.084C24.084 82.5781 24.1636 82.731 24.2973 82.8246C24.431 82.9182 24.6019 82.9406 24.7552 82.8847L24.584 82.415ZM49.6657 43.3105L49.355 42.9188C46.6878 45.0342 41.9909 47.4937 37.1618 49.7188C32.3461 51.9376 27.4471 53.9019 24.4097 55.0312L24.584 55.4998L24.7582 55.9685C27.8155 54.8318 32.7383 52.858 37.5802 50.627C42.4087 48.4022 47.2054 45.9 49.9764 43.7023L49.6657 43.3105ZM49.6657 43.4999H50.1657V43.3105H49.6657H49.1657V43.4999H49.6657ZM49.6657 43.4999L49.355 43.8916C52.1261 46.0893 56.9228 48.5915 61.7512 50.8163C66.5932 53.0472 71.5158 55.021 74.5731 56.1577L74.7474 55.689L74.9216 55.2204C71.8843 54.0911 66.9854 52.1269 62.1697 49.908C57.3406 47.683 52.6437 45.2235 49.9764 43.1081L49.6657 43.4999ZM74.7474 55.689H74.2474V82.4149H74.7474H75.2474V55.689H74.7474ZM74.7474 82.4149L74.9186 81.9452L49.837 72.8032L49.6657 73.273L49.4945 73.7428L74.5762 82.8847L74.7474 82.4149ZM24.584 82.415L24.7552 82.8847L49.837 73.7428L49.6657 73.273L49.4945 72.8032L24.4128 81.9452L24.584 82.415ZM24.584 55.4998H24.084V82.415H24.584H25.084V55.4998H24.584Z",
					fill: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M24.584 28.1893C30.6786 25.9233 44.2274 20.3131 49.6657 16V16.1893C55.1041 20.5024 68.6528 26.1126 74.7474 28.3785V55.1044L49.6657 45.9625L24.584 55.1044V28.1893Z",
					fill: "#F6DCC4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.6657 16H50.1657C50.1657 15.8082 50.056 15.6333 49.8833 15.5498C49.7106 15.4663 49.5053 15.4891 49.355 15.6083L49.6657 16ZM24.584 28.1893L24.4097 27.7206C24.2139 27.7934 24.084 27.9803 24.084 28.1893H24.584ZM49.6657 16.1893H49.1657C49.1657 16.3419 49.2355 16.4862 49.355 16.5811L49.6657 16.1893ZM74.7474 28.3785H75.2474C75.2474 28.1696 75.1175 27.9827 74.9216 27.9098L74.7474 28.3785ZM74.7474 55.1044L74.5762 55.5742C74.7295 55.63 74.9004 55.6076 75.0341 55.514C75.1678 55.4205 75.2474 55.2676 75.2474 55.1044H74.7474ZM49.6657 45.9625L49.837 45.4927C49.7264 45.4524 49.6051 45.4524 49.4945 45.4927L49.6657 45.9625ZM24.584 55.1044H24.084C24.084 55.2676 24.1636 55.4205 24.2973 55.5141C24.431 55.6076 24.6019 55.6301 24.7552 55.5742L24.584 55.1044ZM49.6657 16L49.355 15.6083C46.6878 17.7236 41.9909 20.1831 37.1618 22.4082C32.3461 24.6271 27.4471 26.5913 24.4097 27.7206L24.584 28.1893L24.7582 28.6579C27.8155 27.5212 32.7383 25.5474 37.5802 23.3164C42.4087 21.0917 47.2054 18.5895 49.9764 16.3917L49.6657 16ZM49.6657 16.1893H50.1657V16H49.6657H49.1657V16.1893H49.6657ZM49.6657 16.1893L49.355 16.5811C52.1261 18.7788 56.9228 21.2809 61.7512 23.5057C66.5932 25.7367 71.5158 27.7105 74.5731 28.8472L74.7474 28.3785L74.9216 27.9098C71.8843 26.7806 66.9854 24.8163 62.1697 22.5975C57.3406 20.3724 52.6437 17.9129 49.9764 15.7976L49.6657 16.1893ZM74.7474 28.3785H74.2474V55.1044H74.7474H75.2474V28.3785H74.7474ZM74.7474 55.1044L74.9186 54.6346L49.837 45.4927L49.6657 45.9625L49.4945 46.4322L74.5762 55.5742L74.7474 55.1044ZM24.584 55.1044L24.7552 55.5742L49.837 46.4322L49.6657 45.9625L49.4945 45.4927L24.4128 54.6346L24.584 55.1044ZM24.584 28.1893H24.084V55.1044H24.584H25.084V28.1893H24.584Z",
					fill: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.5834 82.6494C21.7705 69.71 23.4114 62.9679 24.5834 55.3106L49.6652 67.4998V94.6042C35.8351 90.3849 29.2716 85.4623 24.5834 82.6494Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.5834 55.3388C21.7705 42.3994 23.4114 35.6574 24.5834 28L49.6652 40.1893V67.2937C35.8351 63.0743 29.2716 58.1517 24.5834 55.3388Z",
					fill: "#F6DCC4",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M74.7467 82.6496C77.5596 69.7102 75.9187 63.1574 74.7467 55.5L49.6649 67.6893V94.6044C63.495 90.3851 70.0584 85.4625 74.7467 82.6496Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M65.288 72.4V78H64.248V73.272H63.064V72.4H65.288Z",
					fill: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M74.7467 55.339C77.5596 42.3997 75.9187 35.8468 74.7467 28.1895L49.6649 40.3787V67.2939C63.495 63.0745 70.0584 58.1519 74.7467 55.339Z",
					fill: "#F6DCC4",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M47.1534 33.9226L49.9663 39.314C50.5132 38.1419 51.7009 35.4697 52.0759 34.157C52.5447 32.5161 54.6545 29 49.4975 29C45.3719 29 46.2157 32.2817 47.1534 33.9226Z",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M72.001 22.9226L74.8139 28.314C75.3609 27.1419 76.5485 24.4697 76.9236 23.157C77.3924 21.5161 79.5021 18 74.3451 18C70.2195 18 71.0634 21.2817 72.001 22.9226Z",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.7706 21.9226L24.5835 27.314C25.1304 26.1419 26.3181 23.4697 26.6931 22.157C27.1619 20.5161 29.2717 17 24.1147 17C19.9891 17 20.8329 20.2817 21.7706 21.9226Z",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M65.408 50.12V51H61.28V50.304L63.504 48.192C63.7547 47.952 63.9227 47.744 64.008 47.568C64.0987 47.3867 64.144 47.208 64.144 47.032C64.144 46.7707 64.056 46.5707 63.88 46.432C63.704 46.2933 63.4453 46.224 63.104 46.224C62.5333 46.224 62.096 46.4187 61.792 46.808L61.064 46.248C61.2827 45.9547 61.576 45.728 61.944 45.568C62.3173 45.4027 62.7333 45.32 63.192 45.32C63.8 45.32 64.2853 45.464 64.648 45.752C65.0107 46.04 65.192 46.432 65.192 46.928C65.192 47.232 65.128 47.5173 65 47.784C64.872 48.0507 64.6267 48.3547 64.264 48.696L62.768 50.12H65.408Z",
					fill: "#A35705"
				})
			]
		})]
	})]
});
export default SvgLayersCount;
